import Config from '../../Config'

const useFeatureFlags = (featureFlag) => {
  const { featureFlags } = Config
  return featureFlags[featureFlag]
}

export default useFeatureFlags
